"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSuccessResponse = void 0;
const common_1 = require("@wix/wix-vod-shared/common");
const parseSuccessResponse = ({ data }) => {
    const camelCasedData = (0, common_1.keysToCamelCase)(data);
    const { createdTs, updatedTs } = camelCasedData;
    const createdTsDate = new Date(Number(createdTs) * 1000);
    const updatedTsDate = new Date(Number(updatedTs) * 1000);
    return Object.assign(Object.assign({}, camelCasedData), { createdTs: createdTsDate, updatedTs: updatedTsDate });
};
exports.parseSuccessResponse = parseSuccessResponse;
//# sourceMappingURL=success-response.js.map